import _ from 'lodash';
export const transformEducationDetails = (data) => {
  if (!data) return {};
  return {
    candidate: {
      educationalDetails: {
        tenth: {
          schoolName: data.highSchoolSchoolName,
          schoolDetails: {
            startYear: getYearOrNull(data.highSchoolStartDate),
            endYear: getYearOrNull(data.highSchoolEndDate),
            cgpa: data.highSchoolCGPA,
            rank: data.highSchoolRank,
            hasBackPapers: data.hashighSchoolBackLog ? 'YES' : 'NO',
            backPapers: [
              {
                startYear: getYearOrNull(data.highSchoolBacklogStartDate),
                endYear: getYearOrNull(data.highSchoolBacklogEndDate),
                reasons: data.highSchoolBacklogReason ?? '',
              },
            ],
          },
        },
        twelfth: {
          schoolName: data.hseSchoolName,
          schoolDetails: {
            startYear: getYearOrNull(data.hseStartDate),
            endYear: getYearOrNull(data.hseEndDate),
            cgpa: data.hseCGPA,
            rank: data.hseRank,
            hasBackPapers: data.hasHseBackLog ? 'YES' : 'NO',
            backPapers: [
              {
                startYear: getYearOrNull(data.hseBacklogStartDate),
                endYear: getYearOrNull(data.hseBacklogEndDate),
                reasons: data.hseBacklogReason ?? '',
              },
            ],
          },
        },
        hasGraduationDegree: data.haveGraduation === 'YES' ? 'YES' : 'NO',
        graduationLst:
          (data.haveGraduation === 'YES' &&
            data.graduationLst.map((graduationData) => ({
              universityOrCollege: graduationData.graduationUniversityOrCollegeName,
              typeOfCourse: graduationData.graduationCourseType,
              specialisation: graduationData.graduationSpecialization,
              degree: graduationData.graduationDegree,
              universityCollegeDetails: {
                startYear: getYearOrNull(graduationData.graduationUniversityOrCollegeStartDate),
                endYear: getYearOrNull(graduationData.graduationUniversityOrCollegeEndDate),
                cgpa: graduationData.graduationCGPA,
                rank: graduationData.graduationRank,
                hasBackPapers: graduationData.haveGraduationBackLog ? 'YES' : 'NO',
                backPapers: [
                  {
                    startYear: getYearOrNull(graduationData.graduationBacklogStartDate),
                    endYear: getYearOrNull(graduationData.graduationBacklogEndDate),
                    reasons: graduationData.graduationBacklogReason,
                  },
                ],
              },
            }))) ||
          [],
        hasPg: data.havePG === 'YES' ? 'YES' : 'NO',
        pgLst:
          (data.havePG === 'YES' &&
            data.pgLst.map((pgData) => ({
              universityOrCollege: pgData.pgUniversityOrCollegeName,
              typeOfCourse: pgData.pgCourseType,
              specialisation: pgData.pgSpecialization,
              degree: pgData.pgDegree,
              universityCollegeDetails: {
                startYear: getYearOrNull(pgData.pgUniversityOrCollegeStartDate),
                endYear: getYearOrNull(pgData.pgUniversityOrCollegeEndDate),
                cgpa: pgData.pgCGPA,
                rank: pgData.pgRank,
                hasBackPapers: pgData.havePgBackLog ? 'YES' : 'NO',
                backPapers: [
                  {
                    startYear: getYearOrNull(pgData.pgBacklogStartDate),
                    endYear: getYearOrNull(pgData.pgBacklogEndDate),
                    reasons: pgData.pgBacklogReason,
                  },
                ],
              },
            }))) ||
          [],
        hasDoctorate: data.haveDoctorate ? data.haveDoctorate : 'NO',
        doctorates:
          (data.haveDoctorate &&
            data.doctorates &&
            data.doctorates.map((doctorate) => ({
              universityOrCollege: doctorate.doctorateUniversityOrCollegeName,
              typeOfCourse: doctorate.doctorateCourseType,
              specialisation: doctorate.doctorateSpecialization,
              degree: doctorate.doctorateDegree,
              universityCollegeDetails: {
                startYear: getYearOrNull(doctorate.doctorateUniversityOrCollegeStartDate),
                endYear: getYearOrNull(doctorate.doctorateUniversityOrCollegeEndDate),
                hasBackPapers: 'NO',
              },
            }))) ||
          [],
        otherCertificates:
          data.otherCertificates &&
          data.otherCertificates.map((cert) => ({
            title: cert.title,
            universityOrCollege: cert.university,
            startDate: cert.startDate,
            endDate: cert.endDate,
          })),
        educationalDocs: data.educationalDocs,
        assessmentFiles: data.assessmentFiles,
      },
    },
  };
};

export const reverseTransformEducationDetails = (data) => {
  if (!data) return {};

  const safeCertificates =
    (_.get(data, 'otherCertificates') || []).map((cert) => ({
      title: _.get(cert, 'title', ''),
      university: _.get(cert, 'universityOrCollege', ''),
      startDate: _.get(cert, 'startDate')
        ? new Date(_.get(cert, 'startDate'))
        : null,
      endDate: _.get(cert, 'endDate')
        ? new Date(_.get(cert, 'endDate'))
        : null,

    }));

  const safeDoctorates =
    (data.hasDoctorate === 'YES' &&
      _.get(data, 'doctorates', []).map((doctorate) => ({
        doctorateUniversityOrCollegeName: _.get(doctorate, 'universityOrCollege', ''),
        doctorateCourseType: _.get(doctorate, 'typeOfCourse', ''),
        doctorateSpecialization: _.get(doctorate, 'specialisation', ''),
        doctorateDegree: _.get(doctorate, 'degree', ''),
        doctorateUniversityOrCollegeStartDate: _.get(doctorate, 'universityCollegeDetails.startYear')
          ? new Date(new Date().setFullYear(doctorate.universityCollegeDetails.startYear))
          : null,
        doctorateUniversityOrCollegeEndDate: _.get(doctorate, 'universityCollegeDetails.endYear')
          ? new Date(new Date().setFullYear(doctorate.universityCollegeDetails.endYear))
          : null,
      }))) ||
    [];

  const safePgLst =
    (data.hasPg === 'YES' &&
      _.get(data, 'pgLst', []).map((pagData) => ({
        pgUniversityOrCollegeName: _.get(pagData, 'universityOrCollege', ''),
        pgCourseType: _.get(pagData, 'typeOfCourse', ''),
        pgSpecialization: _.get(pagData, 'specialisation', ''),
        pgDegree: _.get(pagData, 'degree', ''),
        pgCGPA: _.get(pagData, 'universityCollegeDetails.cgpa', null),
        pgUniversityOrCollegeEndDate: _.get(pagData, 'universityCollegeDetails.endYear')
          ? new Date(new Date().setFullYear(pagData.universityCollegeDetails.endYear))
          : null,
        pgUniversityOrCollegeStartDate: _.get(pagData, 'universityCollegeDetails.startYear')
          ? new Date(new Date().setFullYear(pagData.universityCollegeDetails.startYear))
          : null,
        pgRank: _.get(pagData, 'universityCollegeDetails.rank', ''),
        havePgBackLog: _.get(pagData, 'universityCollegeDetails.hasBackPapers') === 'YES',
        pgBacklogStartDate:
          _.get(pagData, 'universityCollegeDetails.hasBackPapers') === 'YES' &&
            _.get(pagData, 'universityCollegeDetails.backPapers[0].startYear')
            ? new Date(new Date().setFullYear(pagData.universityCollegeDetails.backPapers[0].startYear))
            : null,
        pgBacklogEndDate:
          _.get(pagData, 'universityCollegeDetails.hasBackPapers') === 'YES' &&
            _.get(pagData, 'universityCollegeDetails.backPapers[0].endYear')
            ? new Date(new Date().setFullYear(pagData.universityCollegeDetails.backPapers[0].endYear))
            : null,
        pgBacklogReason:
          _.get(pagData, 'universityCollegeDetails.hasBackPapers') === 'YES' &&
          _.get(pagData, 'universityCollegeDetails.backPapers[0].reasons', ''),
      }))) ||
    [];

  const safeGraduationLst =
    (data.hasGraduationDegree === 'YES' &&
      _.get(data, 'graduationLst', []).map((graduation) => ({
        graduationUniversityOrCollegeName: _.get(graduation, 'universityOrCollege', ''),
        graduationCourseType: _.get(graduation, 'typeOfCourse', ''),
        graduationSpecialization: _.get(graduation, 'specialisation', ''),
        graduationDegree: _.get(graduation, 'degree', ''),
        graduationUniversityOrCollegeStartDate: _.get(graduation, 'universityCollegeDetails.startYear')
          ? new Date(new Date().setFullYear(graduation.universityCollegeDetails.startYear))
          : null,
        graduationUniversityOrCollegeEndDate: _.get(graduation, 'universityCollegeDetails.endYear')
          ? new Date(new Date().setFullYear(graduation.universityCollegeDetails.endYear))
          : null,
        graduationCGPA: _.get(graduation, 'universityCollegeDetails.cgpa', null),
        graduationRank: _.get(graduation, 'universityCollegeDetails.rank', ''),
        haveGraduationBackLog: _.get(graduation, 'universityCollegeDetails.hasBackPapers') === 'YES',
        graduationBacklogStartDate:
          _.get(graduation, 'universityCollegeDetails.hasBackPapers') === 'YES' &&
            _.get(graduation, 'universityCollegeDetails.backPapers[0].startYear')
            ? new Date(new Date().setFullYear(graduation.universityCollegeDetails.backPapers[0].startYear))
            : null,
        graduationBacklogEndDate:
          _.get(graduation, 'universityCollegeDetails.hasBackPapers') === 'YES' &&
            _.get(graduation, 'universityCollegeDetails.backPapers[0].endYear')
            ? new Date(new Date().setFullYear(graduation.universityCollegeDetails.backPapers[0].endYear))
            : null,
        graduationBacklogReason:
          _.get(graduation, 'universityCollegeDetails.hasBackPapers') === 'YES'
            ? _.get(graduation, 'universityCollegeDetails.backPapers[0].reasons', '')
            : '',
      }))) ||
    [];
  return {
    otherCertificates: safeCertificates,
    haveDoctorate: data.hasDoctorate,
    doctorates: safeDoctorates,
    havePG: data.hasPg === 'YES' ? 'YES' : 'NO',
    pgLst: safePgLst,

    haveGraduation: data.hasGraduationDegree === 'YES' ? 'YES' : 'NO',
    graduationLst: safeGraduationLst,

    hseSchoolName: _.get(data, 'twelfth.schoolName', '') || '',
    hseStartDate: _.get(data, 'twelfth.schoolDetails.startYear')
      ? new Date(_.get(data, 'twelfth.schoolDetails.startYear')).setFullYear(
        _.get(data, 'twelfth.schoolDetails.startYear')
      )
      : null,
    hseEndDate: _.get(data, 'twelfth.schoolDetails.endYear')
      ? new Date(_.get(data, 'twelfth.schoolDetails.endYear')).setFullYear(_.get(data, 'twelfth.schoolDetails.endYear'))
      : null,
    hseCGPA: _.get(data, 'twelfth.schoolDetails.cgpa'),
    hseRank: _.get(data, 'twelfth.schoolDetails.rank'),
    hasHseBackLog: _.get(data, 'twelfth.schoolDetails.hasBackPapers') === 'YES',
    hseBacklogStartDate:
      _.get(data, 'twelfth.schoolDetails.hasBackPapers') === 'YES' &&
        _.get(data, 'twelfth.schoolDetails.backPapers[0].startYear')
        ? new Date(_.get(data, 'twelfth.schoolDetails.backPapers[0].startYear')).setFullYear(
          _.get(data, 'twelfth.schoolDetails.backPapers[0].startYear')
        )
        : null,
    hseBacklogEndDate:
      _.get(data, 'twelfth.schoolDetails.hasBackPapers') === 'YES' &&
        _.get(data, 'twelfth.schoolDetails.backPapers[0].endYear')
        ? new Date(_.get(data, 'twelfth.schoolDetails.backPapers[0].endYear')).setFullYear(
          _.get(data, 'twelfth.schoolDetails.backPapers[0].endYear')
        )
        : null,
    hseBacklogReason: _.get(data, 'twelfth.schoolDetails.backPapers[0].reasons', ''),

    highSchoolSchoolName: _.get(data, 'tenth.schoolName'),
    highSchoolStartDate: _.get(data, 'tenth.schoolDetails.startYear')
      ? new Date(_.get(data, 'tenth.schoolDetails.startYear')).setFullYear(_.get(data, 'tenth.schoolDetails.startYear'))
      : null,
    highSchoolEndDate: _.get(data, 'tenth.schoolDetails.endYear')
      ? new Date(_.get(data, 'tenth.schoolDetails.endYear')).setFullYear(_.get(data, 'tenth.schoolDetails.endYear'))
      : null,
    highSchoolCGPA: _.get(data, 'tenth.schoolDetails.cgpa'),
    highSchoolRank: _.get(data, 'tenth.schoolDetails.rank'),
    hashighSchoolBackLog: _.get(data, 'tenth.schoolDetails.hasBackPapers') === 'YES',
    highSchoolBacklogStartDate:
      _.get(data, 'tenth.schoolDetails.hasBackPapers') === 'YES' &&
        _.get(data, 'tenth.schoolDetails.backPapers[0].startYear')
        ? new Date(_.get(data, 'tenth.schoolDetails.backPapers[0].startYear')).setFullYear(
          _.get(data, 'tenth.schoolDetails.backPapers[0].startYear')
        )
        : null,
    highSchoolBacklogEndDate:
      _.get(data, 'tenth.schoolDetails.hasBackPapers') === 'YES' &&
        _.get(data, 'tenth.schoolDetails.backPapers[0].endYear')
        ? new Date(_.get(data, 'tenth.schoolDetails.backPapers[0].endYear')).setFullYear(
          _.get(data, 'tenth.schoolDetails.backPapers[0].endYear')
        )
        : null,
    highSchoolBacklogReason: _.get(data, 'tenth.schoolDetails.backPapers[0].reasons', ''),
    educationalDocs: _.get(data, 'educationalDocs'),
    assessmentFiles: _.get(data, 'assessmentFiles'),
  };
};

const getYearOrNull = (dateStr) => {
  return dateStr ? new Date(dateStr).getFullYear() : null;
};
